import { useState } from "react";
import { platformService } from "../../../services/platform.service";
import { EditTicketAttachmentsProps } from "./EditableTicketAttachment";
import { useSetState } from "../../../../AppState";
import { deleteTicketFilesViaApi, removeDeletedFileIdsFromUploadingState } from "./deleteTicketAttachments";

const api = new platformService();

export const useDeleteComment = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<any>(null);
  const setAppState = useSetState();

  const openDeleteDialog = () => {
    setIsDialogOpen(true);
    setError(null);
  };

  const closeDeleteDialog = () => {
    setIsDialogOpen(false);
    setError(null);
  };

  const deleteComment = async (
    commentId: number,
    onSuccess?: () => void,
    attachments?: EditTicketAttachmentsProps[]
  ) => {
    setIsDeleting(true);
    setError(null);

    try {
      if (attachments && attachments.length > 0) {
        const { successful } = await deleteTicketFilesViaApi(api, attachments);
        if (successful.length > 0) {
          removeDeletedFileIdsFromUploadingState(setAppState, new Set(successful.map((d) => d.fileId)));
        }
      }

      // Delete the comment itself
      const response = await api.deleteComment(commentId);
      setIsDeleting(false);
      setIsDialogOpen(false);
      
      if (onSuccess) {
        onSuccess();
      }
      
      return response;
    } catch (err) {
      setError(err);
      setIsDeleting(false);
      throw err;
    }
  };

  return {
    isDialogOpen,
    openDeleteDialog,
    closeDeleteDialog,
    deleteComment,
    isDeleting,
    error,
  };
};
